import i18n from '@/i18n';
import store from '@/store';

export default {
  install(Vue, options) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$i18n = function(path) {
      const lang = store.getters['lang/getLang'];
      const defaultLang = store.state.lang.default;
      const pathArr = path.split('.');
      if (pathArr[0] === undefined) return '';
      let found = i18n[lang];
      let foundDefault = i18n[defaultLang];

      for (const step of pathArr) {
        if (!found) return foundDefault || '';
        found = found[step];
        foundDefault = foundDefault[step];
      }
      return found;
    };
  },
};

export const getLang = (langMap) => {
  const lang = store.getters['lang/getLang'];
  let langSet = langMap[lang];
  if (langSet) {
    return { title: langSet.title, description: langSet.description };
  }
  const langDefault = store.state.lang.default;
  langSet = langMap[langDefault];
  if (!langSet) return { title: '', description: '' };
  return { title: langSet.title, description: langSet.description };
};



// WEBPACK FOOTER //
// ./src/plugin/LangControl.js